export enum DataValueType
{
    NoDataValueType = 0,
    Integer = 1,
    String = 2,
    Entity = 3,
    Decimal = 4,
    Boolean = 5,
    Url = 6,
    EntityMultiSelect = 7,
    Date = 8,
    DateRange = 9,
    Representative = 10,
    GridVerification = 11,
    Hour = 12,
    DateHour = 13,
    DateHourRange = 14
}